"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSankeyDrawNodesLabel = void 0;
const d3 = __importStar(require("d3"));
const SankeyDrag_1 = require("./SankeyDrag");
const SankeyDrawFunction_1 = require("./SankeyDrawFunction");
const OpenSankeyDrawNodesLabel = (data, set_data, multi_selected_nodes, getLinkValue) => {
    const display_nodes = data.nodes;
    const display_links = data.links;
    const add_nodes_label = () => {
        //------------------LABEL------------------------
        // Add node label and apply parameter
        const ggg_nodes = d3.selectAll('.ggg_nodes');
        ggg_nodes
            .append('text')
            .attr('fill', n => (n.display_style.label_color) ? 'white' : 'black')
            .classed('node', true)
            .classed('node_text', true)
            .classed('test_new_file', true)
            .attr('id', n => n.idNode + '_text')
            .attr('x', n => SankeyDrawFunction_1.node_label_posX(n))
            .attr('y', n => SankeyDrawFunction_1.node_label_posY(n, data))
            .attr('text-anchor', n => {
            if (n.display_style.label_horiz == 'middle') {
                return 'middle';
            }
            else if (n.display_style.label_horiz == 'left') {
                return 'end';
            }
            else if (n.display_style.label_horiz == 'right') {
                return 'start';
            }
            else {
                return 'start';
            }
        })
            .attr('visibility', n => n.node_visible && n.label_visible ? 'visible' : 'hidden')
            .style('text-align', 'center')
            .style('font-weight', n => (n.display_style.bold) ? 'bold' : 'normal')
            .style('font-style', n => (n.display_style.italic) ? 'italic' : 'normal')
            .style('font-size', n => n.display_style.font_size + 'px')
            .style('font-family', () => data.display_style.node_font_family_selected)
            .style('text-transform', n => (n.display_style.uppercase) ? 'uppercase' : 'none')
            .text(n => SankeyDrawFunction_1.node_label_text(data, n))
            .each(n => SankeyDrawFunction_1.textNodeWrap(n, data));
        // Display value of nodes
        // Value of nodes are the maximum between the sum of input links and the sum of output links
        ggg_nodes.append('text')
            .attr('fill', n => (n.display_style.label_color) ? 'white' : 'black')
            .classed('node', true)
            .classed('node_text_value', true)
            .attr('id', n => n.idNode + '_text_value')
            .attr('x', n => SankeyDrawFunction_1.node_value_posX(n))
            .attr('y', n => SankeyDrawFunction_1.node_value_posY(n))
            .attr('text-anchor', () => 'middle')
            .attr('visibility', n => n.node_visible && n.show_value ? 'visible' : 'hidden')
            // .style('text-align', 'center')
            // .style('font-weight', n => ((n as SankeyNode).display_style.bold) ? 'bold' : 'normal')
            // .style('font-style', n => ((n as SankeyNode).display_style.italic) ? 'italic' : 'normal')
            .style('font-family', () => data.display_style.node_font_family_selected)
            .style('font-size', n => n.display_style.value_font_size + 'px')
            // .style('text-transform', n => ((n as SankeyNode).display_style.uppercase) ? 'uppercase' : 'none')
            .text(n => SankeyDrawFunction_1.textNodeValue(n, data, display_links, display_nodes, getLinkValue));
        // Drag zone for changing label box width
        // (if the label length exceed a certian length the text is wrapped, the box visually represent the length to not exceed)
        ggg_nodes
            .filter(n => n.x_label == undefined)
            .append('rect')
            .attr('class', 'box_width_threshold')
            .attr('x', n => {
            const nn = n;
            const width = +d3.select(' .opensankey #' + nn.idNode).attr('width');
            if (nn.x_label) {
                return nn.x_label;
            }
            else if (nn.display_style.label_horiz == 'middle') {
                return width / 2 - nn.display_style.label_box_width / 2;
            }
            else if (nn.display_style.label_horiz == 'left') {
                return -nn.display_style.label_box_width;
            }
            else if (nn.display_style.label_horiz == 'right') {
                return width;
            }
            else {
                return 0;
            }
        })
            .attr('y', n => {
            const nn = n;
            const height = +d3.select(' .opensankey #' + nn.idNode).attr('height');
            if (nn.y_label && data.show_structure !== 'structure') {
                return nn.y_label;
            }
            else if (nn.display_style.label_vert == 'middle') {
                return 0;
            }
            else if (nn.display_style.label_vert == 'top') {
                return -4;
            }
            else if (nn.display_style.label_vert == 'bottom') {
                return height;
            }
            else {
                return 0;
            }
        })
            .attr('width', n => n.display_style.label_box_width)
            .attr('height', n => {
            var _a;
            const h = (_a = document.getElementById(n.idNode + '_text')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
            return (h != undefined) ? h : 25;
        })
            .attr('fill', 'grey')
            .attr('fill-opacity', '0')
            .attr('stroke', 'grey')
            // .attr('stroke-dasharray',('3,2'))
            .attr('stroke-width', '2px')
            .attr('cursor', 'ew-resize')
            .attr('visibility', n => (multi_selected_nodes.current.includes(n) ? 'visible' : 'hidden'))
            .call(SankeyDrag_1.dragNodeTextEventWidthBoxEvent(data, set_data));
    };
    add_nodes_label();
};
exports.OpenSankeyDrawNodesLabel = OpenSankeyDrawNodesLabel;
